import { render } from "./ApiReferenceModal.vue?vue&type=template&id=5bfd4d64&scoped=true"
import script from "./ApiReferenceModal.vue?vue&type=script&lang=ts"
export * from "./ApiReferenceModal.vue?vue&type=script&lang=ts"

import "./ApiReferenceModal.vue?vue&type=style&index=0&id=5bfd4d64&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5bfd4d64"

export default script